/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitPartialYesNoEnum } from './MonitPartialYesNoEnum';
import {
    MonitPartialYesNoEnumFromJSON,
    MonitPartialYesNoEnumFromJSONTyped,
    MonitPartialYesNoEnumToJSON,
} from './MonitPartialYesNoEnum';

/**
 * 
 * @export
 * @interface MonitPrivacyPolicyAnalysisExternalResult
 */
export interface MonitPrivacyPolicyAnalysisExternalResult {
    /**
     * 
     * @type {string}
     * @memberof MonitPrivacyPolicyAnalysisExternalResult
     */
    last_updated?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPrivacyPolicyAnalysisExternalResult
     */
    contact_email?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPrivacyPolicyAnalysisExternalResult
     */
    contact_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPrivacyPolicyAnalysisExternalResult
     */
    contact_address?: string;
    /**
     * 
     * @type {MonitPartialYesNoEnum}
     * @memberof MonitPrivacyPolicyAnalysisExternalResult
     */
    mention_of_childrens_data?: MonitPartialYesNoEnum;
    /**
     * 
     * @type {MonitPartialYesNoEnum}
     * @memberof MonitPrivacyPolicyAnalysisExternalResult
     */
    mention_of_opt_out?: MonitPartialYesNoEnum;
    /**
     * 
     * @type {MonitPartialYesNoEnum}
     * @memberof MonitPrivacyPolicyAnalysisExternalResult
     */
    advanced_privacy_controls?: MonitPartialYesNoEnum;
    /**
     * 
     * @type {MonitPartialYesNoEnum}
     * @memberof MonitPrivacyPolicyAnalysisExternalResult
     */
    mention_of_generic_tracking_technologies?: MonitPartialYesNoEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitPrivacyPolicyAnalysisExternalResult
     */
    specific_tracking_technologies?: Array<string>;
}

/**
 * Check if a given object implements the MonitPrivacyPolicyAnalysisExternalResult interface.
 */
export function instanceOfMonitPrivacyPolicyAnalysisExternalResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitPrivacyPolicyAnalysisExternalResultFromJSON(json: any): MonitPrivacyPolicyAnalysisExternalResult {
    return MonitPrivacyPolicyAnalysisExternalResultFromJSONTyped(json, false);
}

export function MonitPrivacyPolicyAnalysisExternalResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPrivacyPolicyAnalysisExternalResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'last_updated': !exists(json, 'last_updated') ? undefined : json['last_updated'],
        'contact_email': !exists(json, 'contact_email') ? undefined : json['contact_email'],
        'contact_phone': !exists(json, 'contact_phone') ? undefined : json['contact_phone'],
        'contact_address': !exists(json, 'contact_address') ? undefined : json['contact_address'],
        'mention_of_childrens_data': !exists(json, 'mention_of_childrens_data') ? undefined : MonitPartialYesNoEnumFromJSON(json['mention_of_childrens_data']),
        'mention_of_opt_out': !exists(json, 'mention_of_opt_out') ? undefined : MonitPartialYesNoEnumFromJSON(json['mention_of_opt_out']),
        'advanced_privacy_controls': !exists(json, 'advanced_privacy_controls') ? undefined : MonitPartialYesNoEnumFromJSON(json['advanced_privacy_controls']),
        'mention_of_generic_tracking_technologies': !exists(json, 'mention_of_generic_tracking_technologies') ? undefined : MonitPartialYesNoEnumFromJSON(json['mention_of_generic_tracking_technologies']),
        'specific_tracking_technologies': !exists(json, 'specific_tracking_technologies') ? undefined : json['specific_tracking_technologies'],
    };
}

export function MonitPrivacyPolicyAnalysisExternalResultToJSON(value?: MonitPrivacyPolicyAnalysisExternalResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'last_updated': value.last_updated,
        'contact_email': value.contact_email,
        'contact_phone': value.contact_phone,
        'contact_address': value.contact_address,
        'mention_of_childrens_data': MonitPartialYesNoEnumToJSON(value.mention_of_childrens_data),
        'mention_of_opt_out': MonitPartialYesNoEnumToJSON(value.mention_of_opt_out),
        'advanced_privacy_controls': MonitPartialYesNoEnumToJSON(value.advanced_privacy_controls),
        'mention_of_generic_tracking_technologies': MonitPartialYesNoEnumToJSON(value.mention_of_generic_tracking_technologies),
        'specific_tracking_technologies': value.specific_tracking_technologies,
    };
}

